import cn from 'classnames';
import React from 'react';
import { SUB } from 'src/app/consts';
import { useAppSelector } from 'src/app/redux/createAction';
import { DivProps } from 'src/shared/types/props';
import { ButtonPrimary } from 'src/shared/ui/_buttons/ButtonPrimary';
import { Heading } from 'src/shared/ui/Heading';
import { Paragraph } from 'src/shared/ui/Paragraph';
import { CompanyCard } from 'src/widgets/CompanyCard';
import s from './Welcome.module.scss';

export const Welcome: React.FC<DivProps> = (props) => {
	const { className, ...divProps } = props;

	// * Selector
	const companiesInfo = useAppSelector((state) => state.userInfo.companiesLookupResult);

	// * Render
	return (
		<>
			<div
				{...divProps}
				className={cn(s.container, className)}
			>
				<div className={s.inner}>
					<div className={s.inner__left}>
						<Heading
							level={1}
							color="light"
							marginBottom="m"
						>
							Denominator<sup>{SUB}</sup>
						</Heading>

						<Paragraph color="light">Welcome to our data portal where you can upload or edit your company’s information to received company assessment and certificate.</Paragraph>
						<Paragraph color="light">If you have any questions or need assistance, please contact our team</Paragraph>

						<ButtonPrimary
							href="https://www.denominator.com/contact?source=denominator-assessment&title=Contact%20our%20team"
							// @ts-ignore
							target="_blank"
						>
							Contact Us
						</ButtonPrimary>
					</div>

					{companiesInfo && (
						<div className={s.inner__right}>
							<Heading
								data-test={'company_card_my_companies'}
								level={3}
								color="light"
								marginBottom="m"
							>
								My company
							</Heading>

							{companiesInfo.map((companyInfo) => (
								<CompanyCard
									key={companyInfo.id}
									companyId={companyInfo.id}
									companyName={companyInfo.name}
								/>
							))}
						</div>
					)}
				</div>
			</div>
		</>
	);
};
